// import map from '~/ui/Pages/MapPage/MapPage';
import model from '~/ui/Pages/ModelPage/ModelPage';
import notFound from '~/ui/Pages/NotFoundPage/NotFoundPage';
import notAuthorized from '~/ui/Pages/NotAuthorized/NotAuthorized';
import error from '~/ui/Pages/ErrorPage/ErrorPage';
import auth from '~/ui/Pages/AuthPage/AuthPage';
import forgot_password from '~/ui/Pages/AuthPage/ForgotPassword';
import reset_password from '~/ui/Pages/AuthPage/ResetPassword';
// import dashboard from '~/ui/Pages/DashboardPage/DashboardPage';
// import help from '~/ui/Pages/HelpPage/HelpPage';

export const guestRoutes = {
    forgot_password,
    reset_password,
}

export default {
    auth,
    // map,
    model,
    notFound,
    notAuthorized,
    error,
    
    forgot_password,
    reset_password,
    // dashboard,
    // help
};